export default {
  props: {
    value: { type: Object, default: () => {} }
  },
  watch: {
    value: {
      handler (v) {
        this.form = { ...this.form, ...v }
      },
      immediate: true
    }
  },
  methods: {
    __validateForm () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('validated', { ...this.form })
        this.$emit('input', { ...this.form })
      }
      return !this.$v.form.$invalid
    },
    __skipValidation () {
      this.$emit('validated', { ...this.form })
      this.$emit('input', { ...this.form })
      return true
    }
  }
}
